import React from "react";

import Dashboard from "../features/dashboard/Dashboard";

function DashboardPage(props) {
  return <Dashboard {...props}></Dashboard>;
}

export default DashboardPage;
